// extracted by mini-css-extract-plugin
module.exports = {"raiseHand":"RaiseHand_raiseHand__2ZXa3"};